import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=f1131f0c&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTag: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Tag.vue').default,UiStatsIcons: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Stats/Icons.vue').default})
